import { useMemo } from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { IIconButtonProps } from './IconButton.types';

import './IconButton.styles.scss';

const IconButton = ({
  className = '',
  type = 'text',
  size = 'small',
  tooltip,
  color = 'default',
  disabled,
  ...props
}: IIconButtonProps) => {
  const { t } = useTranslation();

  const colorClass = useMemo(() => {
    if (type === 'text') {
      if (color === 'primary') {
        return 'np-icon-button__text--primary';
      }

      if (color === 'default') {
        return 'np-icon-button__text--default';
      }

      if (color === 'red') {
        return 'np-icon-button__text--red';
      }
    }
  }, [color, type]);

  return (
    <Tooltip title={!disabled && t(tooltip)}>
      <Button
        size={size}
        type={type}
        disabled={disabled}
        shape="circle"
        className={`np-icon-button ${colorClass} ${className}`}
        {...props}
      />
    </Tooltip>
  );
};

export default IconButton;
